// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3P430","inner":"Footer_inner__2N_RY"};